import { BetTicketStatus } from "@enum/ticket-status.enum";

export const TicketStatusAliasMap: Record<string, BetTicketStatus> = {
  // CANCELLED
  "cancel": BetTicketStatus.CANCELLED,
  "cancelled": BetTicketStatus.CANCELLED,
  "annule": BetTicketStatus.CANCELLED,
  "annulé": BetTicketStatus.CANCELLED,
  "void": BetTicketStatus.CANCELLED,
  '3': BetTicketStatus.CANCELLED,

  // WON
  "gagnant": BetTicketStatus.WON,
  'win': BetTicketStatus.WON,
  'won': BetTicketStatus.WON,
  '1': BetTicketStatus.WON,

  // LOST
  'perdu': BetTicketStatus.LOST,
  'loss': BetTicketStatus.LOST,
  'lost': BetTicketStatus.LOST,
  '2': BetTicketStatus.LOST,

  // PAID
  'paye': BetTicketStatus.PAID,
  'payé': BetTicketStatus.PAID,
  'paid': BetTicketStatus.PAID,

  // NOT PROCESSED
  'place': BetTicketStatus.NOT_PROCESSED,
  'pending': BetTicketStatus.NOT_PROCESSED,
  'open': BetTicketStatus.NOT_PROCESSED,
  '0': BetTicketStatus.NOT_PROCESSED,

  // PROCESSED / CLOSED
  'process': BetTicketStatus.PROCESSED,
  'processed': BetTicketStatus.PROCESSED,
  'cloturer': BetTicketStatus.CALCULATED,
  'closed': BetTicketStatus.CALCULATED,

  // VALID / INVALID
  'valid': BetTicketStatus.VALID,
  'non_valid': BetTicketStatus.INVALID,
  'invalid': BetTicketStatus.INVALID,

  // ENABLE / DISABLE
  'enable': BetTicketStatus.ENABLED,
  'enabled': BetTicketStatus.ENABLED,
  'disabled': BetTicketStatus.DISABLED,

  // SUSPENDED
  'suspended': BetTicketStatus.SUSPENDED
};
